// eslint-disable-next-line import/prefer-default-export
export const QUANTITY_MODES = {
  RATE_PER_ACRE: 'ratePerAcre',
  TOTAL_PRODUCT: 'totalProduct',
  RATE_PER_TANK: 'ratePerTank'
};

export const APPLIED_AREA_TOOLTIP_TEXT =
  'This represents the applied area for this product, not the overall application area';

export const DEFAULT_QUANTITY_MODE = QUANTITY_MODES.RATE_PER_ACRE;

export const DRAWER_WIDTH = '520px';

export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  INVALID_NUMBER: 'Please enter a valid number',
  NEGATIVE_NUMBER: 'Value cannot be negative',
  EXCEEDS_100_PERCENT: 'Cannot exceed 100%',
  ZERO_NOT_ALLOWED: 'Value cannot be zero'
};
